import { render, staticRenderFns } from "./vrCompany.vue?vue&type=template&id=03ee61ca"
import script from "./vrCompany.vue?vue&type=script&lang=js"
export * from "./vrCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports